<template>
    <div style="display: flex; flex-direction: column; width: 100%;">
        <div style="display: flex; align-items: baseline; justify-content: space-between; width: 100%;">
            <div style="font-size: 11px; color: #5f5f5f;">{{ label }}</div>
            <div style="font-size: 12px; font-weight: 700; color: #b33700; white-space: nowrap; margin-left: 4px;">{{ valuePrefix }}{{ displayedValue }}{{ valueSuffix }}</div>
        </div>

        <input
            type="range"
            class="threshold-slider"
            :min="sliderMin"
            :max="sliderMax"
            :step="sliderStep"
            :value="sliderValue"
            @input="onInput"
            style="width: 100%; margin: 10px 0 4px 0;"
        />

        <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 2px;">
            <div
                v-for="tick in tickLabels"
                :key="`tick-${tick}`"
                style="font-size: 10px; color: #acacac;"
            >{{ tick }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ThresholdSlider",

    props: {
        label: {
            type: String,
            default: "",
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
        modelValue: {
            type: Number,
            default: 0,
        },
        valuePrefix: {
            type: String,
            default: "",
        },
        valueSuffix: {
            type: String,
            default: "",
        },
        allowedValues: {
            type: Array,
            default: null,
        },
    },

    emits: ["update:modelValue"],

    computed: {
        discreteValues() {
            if (!Array.isArray(this.allowedValues) || this.allowedValues.length === 0) {
                return null;
            }

            return this.allowedValues.map(Number).filter((value) => Number.isFinite(value));
        },
        sliderMin() {
            return this.discreteValues ? 0 : this.min;
        },
        sliderMax() {
            return this.discreteValues ? this.discreteValues.length - 1 : this.max;
        },
        sliderStep() {
            return this.discreteValues ? 1 : this.step;
        },
        sliderValue() {
            if (!this.discreteValues) {
                return this.modelValue;
            }

            return this.nearestIndex(this.modelValue);
        },
        displayedValue() {
            if (!this.discreteValues) {
                return this.modelValue;
            }

            return this.discreteValues[this.sliderValue];
        },
        tickLabels() {
            if (this.discreteValues) {
                return this.discreteValues;
            }

            return [this.min, this.max];
        },
    },

    methods: {
        nearestIndex(value) {
            let bestIndex = 0;
            let bestDistance = Infinity;

            this.discreteValues.forEach((allowed, index) => {
                const distance = Math.abs(allowed - value);
                if (distance < bestDistance) {
                    bestDistance = distance;
                    bestIndex = index;
                }
            });

            return bestIndex;
        },
        onInput(event) {
            const sliderPosition = Number(event.target.value);
            const nextValue = this.discreteValues
                ? this.discreteValues[sliderPosition]
                : sliderPosition;

            this.$emit("update:modelValue", nextValue);
        },
    },
};
</script>

<style scoped>
.threshold-slider {
    -webkit-appearance: none;
    appearance: none;
    height: 4px;
    border-radius: 2px;
    background: #e3d5cc;
    outline: none;
    cursor: pointer;
}

.threshold-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ff4e00;
    border: none;
    cursor: pointer;
}

.threshold-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ff4e00;
    border: none;
    cursor: pointer;
}

.threshold-slider::-moz-range-track {
    height: 4px;
    border-radius: 2px;
    background: #e3d5cc;
}
</style>
